export { default as BackgroundImage, BackgroundImageSrc } from './BackgroundImage';